export default __webpack_public_path__ + "static/media/about.663be9ad.svg";